import { Box, styled } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

export const PDFPageSelectionControlsContainer = styled(Box, {
  shouldForwardProp: prop => prop !== '$allowPageSelection' && prop !== '$isPopped',
})<{ $allowPageSelection: boolean; $isPopped?: boolean }>(({ $allowPageSelection }) => ({
  borderBottom: '1px solid #D8E3EE',
  backgroundColor: 'white',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'stretch',
  width: '100%',
  height: 'fit-content',
  minWidth: 0,
  gap: '12px',
  flexWrap: 'nowrap',
  alignContent: 'space-around',
  padding: '6px 10px',
  position: $allowPageSelection ? 'sticky' : 'relative',
  top: $allowPageSelection ? 0 : undefined,
  zIndex: $allowPageSelection ? 10000 : undefined,
}));

export const actionsBoxSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  gap: 1,
  ml: 'auto',
  minWidth: 0,
};
